<template>
  <tbody>
    <tr v-for="(lot, i) in rows" :key="i">
      <td class="text-center white-space-nowrap">
        {{ lot.name }}
      </td>
      <td class="text-center white-space-nowrap">
        {{ coveredAreas[lot.numberLot] }}
      </td>
      <td class="text-center" v-for="(_, week) in columns" :key="week">
        {{ getNumberClusters(week, lot.numberLot) }}
      </td>
      <td class="text-center">
        <strong style="font-size: 16px">
          {{ getTotalRow(lot.numberLot) }}
        </strong>
      </td>
    </tr>
  </tbody>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';

export default {
  name: 'tbody-pockets',
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    coveredAreas: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    data: {
      type: Array | Object,
      default: [],
    },
    totalRows: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'byLots',
    },
  },
  mixins: [MixinMasters],
  methods: {
    getNumberClusters(week, lot) {
      try {
        return Formatter.formatNumber(
          getSumOfValorFromArray(
            this.data[week][lot].map((data) => {
              if (this.option === 'byLotsHa') {
                return Number(data.covered_area) > 0
                  ? data.number_clusters / data.covered_area
                  : '';
              }
              return data.number_clusters;
            })
          )
        );
      } catch (error) {
        return '';
      }
    },
    getTotalRow(lot) {
      let sum = '';
      try {
        if (this.option === 'byLotsHa') {
          sum =
            this.coveredAreas[lot] && Number(this.coveredAreas[lot]) > 0
              ? getSumOfValorFromArray(this.totalRows[lot]) /
                this.coveredAreas[lot]
              : 0;
        } else {
          sum = getSumOfValorFromArray(this.totalRows[lot]);
        }
      } catch (error) {}
      return Formatter.formatNumber(sum);
    },
  },
};
</script>
